export async function enableMocks(): Promise<void> {
  if (typeof window === 'undefined') return;

  if (import.meta.env['VITE_USE_MOCKS'] !== 'true') return;

  const { worker } = await import('./browser');
  await worker.start({ onUnhandledRequest: 'warn' });
  console.info('[MSW] mocks enabled');
}
